module.exports = __webpack_public_path__ + "img/show-group-chat.a2c5bb29.jpg";